module.exports = __webpack_public_path__ + "media/images/emblems/Grossdietwil_LU-fcb753e0cdf87fce1bc0d83868b2e59f.png";